import { html } from 'lit-html';

export default {
  title: 'Components/Alert',
  tags: ['autodocs'],
  parameters: {
    docs: {
      description: {
        component: `
To use the \`dda-alert\` component, pass the following props and handle the emitted events:

\`\`\`html
<dda-alert
  type="primary"
  variation="info"
  title_text="Alert Title"
  description="This is an informational alert."
  primary_button="Primary"
  secondary_button="Secondary"
  close_button_name="closeAlert"
  @closeClick="..."
  @firstClick="..."
  @secondClick="..."
></dda-alert>
\`\`\`
        `,
      },
    },
  },
  argTypes: {
    type: {
      control: 'select',
      options: ['primary', 'secondary'],
      description: 'Type of the alert component',
    },
    variation: {
      control: 'select',
      options: ['info', 'warning', 'error', 'success'],
      description: 'Variation of the alert component',
    },
    title_text: { control: 'text', description: 'Title text' },
    description: { control: 'text', description: 'Description' },
    button_text: { control: 'text', description: 'Legacy button text (unused)' },
    secondary_button: { control: 'text', description: 'Secondary button text' },
    secondary_button_link: { control: 'text', description: 'Unused for now' },
    primary_button: { control: 'text', description: 'Primary button text' },
    primary_button_link: { control: 'text', description: 'Unused for now' },
    close_button_name: { control: 'text', description: 'Close button name' },
    custom_class: {
      control: 'text',
      description: 'Custom class to be applied to the alert',
    },
    component_mode: {
      control: 'check',
      options: ['light-mode'],
      description: 'Mode of the alert component',
    },
  },
};

const Template = ({
  type,
  variation,
  title_text,
  description,
  button_text,
  close_button_name,
  custom_class,
  component_mode,
  secondary_button,
  secondary_button_link,
  primary_button,
  primary_button_link,
}) => html`
  <dda-alert
    type=${type}
    variation=${variation}
    title_text=${title_text}
    description=${description}
    button_text=${button_text}
    close_button_name=${close_button_name}
    custom_class=${custom_class}
    component_mode=${component_mode}
    secondary_button=${secondary_button}
    secondary_button_link=${secondary_button_link}
    primary_button=${primary_button}
    primary_button_link=${primary_button_link}
    @closeClick=${() => console.log('Close clicked')}
    @firstClick=${() => console.log('Secondary button clicked')}
    @secondClick=${() => console.log('Primary button clicked')}
  ></dda-alert>
`;

export const AlertInfo = Template.bind({});
AlertInfo.args = {
  type: 'primary',
  variation: 'info',
  title_text: 'Alert Title',
  description: 'This is an informational alert.',
  button_text: 'Learn more',
  close_button_name: 'closeAlert',
  custom_class: '',
  component_mode: '',
  secondary_button: 'Secondary',
  secondary_button_link: '',
  primary_button: 'Primary',
  primary_button_link: '',
};

export const AlertWarning = Template.bind({});
AlertWarning.args = {
  type: 'primary',
  variation: 'warning',
  title_text: 'Alert Title',
  description: 'This is an informational alert.',
  button_text: 'Learn more',
  close_button_name: 'closeAlert',
  custom_class: '',
  component_mode: '',
  secondary_button: 'Secondary',
  secondary_button_link: '',
  primary_button: 'Primary',
  primary_button_link: '',
};

export const AlertError = Template.bind({});
AlertError.args = {
  type: 'primary',
  variation: 'error',
  title_text: 'Alert Title',
  description: 'This is an informational alert.',
  button_text: 'Learn more',
  close_button_name: 'closeAlert',
  custom_class: '',
  component_mode: '',
  secondary_button: 'Secondary',
  secondary_button_link: '',
  primary_button: 'Primary',
  primary_button_link: '',
};

export const AlertSuccess = Template.bind({});
AlertSuccess.args = {
  type: 'primary',
  variation: 'success',
  title_text: 'Alert Title',
  description: 'This is an informational alert.',
  button_text: 'Learn more',
  close_button_name: 'closeAlert',
  custom_class: '',
  component_mode: '',
  secondary_button: 'Secondary',
  secondary_button_link: '',
  primary_button: 'Primary',
  primary_button_link: '',
};
